import { ApplianceDetailsFormValue } from '../../models/appliance-details-stepped/forms/appliance-details-form-value.type';

export const mockApplianceDetailsFormValue: ApplianceDetailsFormValue = {
  applianceCategory: 'Fridges & Freezers',
  applianceCode: 'CN',
};
